import { atom, type Getter, type Setter } from 'jotai';

export type ModalMode = 'add' | 'edit' | 'view' | 'delete' | null;

export interface ModalState<T = unknown> {
  isOpen: boolean;
  mode: ModalMode;
  data: T | null;
}

const modalAtom = atom<ModalState>({
  isOpen: false,
  mode: null,
  data: null,
});

export const isModalOpenAtom = atom((get) => get(modalAtom).isOpen);
export const modalModeAtom = atom((get) => get(modalAtom).mode);
export const modalDataAtom = atom((get) => get(modalAtom).data);

export const openModalAtom = atom(
  null,
  <T>(_get: Getter, set: Setter, { mode, data }: { mode: ModalMode; data?: T }) => {
    set(modalAtom, { isOpen: true, mode, data: data ?? null });
  },
);

export const closeModalAtom = atom(null, (_get: Getter, set: Setter) => {
  set(modalAtom, { isOpen: false, mode: null, data: null });
});

export const setModalModeAtom = atom(null, (_get: Getter, set: Setter, mode: ModalMode) => {
  set(modalAtom, (prev) => ({ ...prev, mode }));
});

// Comment modal state (separate from main modal to avoid conflicts)
const commentModalAtom = atom<ModalState>({
  isOpen: false,
  mode: null,
  data: null,
});

export const isCommentModalOpenAtom = atom((get) => get(commentModalAtom).isOpen);
export const commentModalModeAtom = atom((get) => get(commentModalAtom).mode);
export const commentModalDataAtom = atom((get) => get(commentModalAtom).data);

export const openCommentModalAtom = atom(
  null,
  <T>(_get: Getter, set: Setter, { mode, data }: { mode: ModalMode; data?: T }) => {
    set(commentModalAtom, { isOpen: true, mode, data: data ?? null });
  },
);

export const closeCommentModalAtom = atom(null, (_get: Getter, set: Setter) => {
  set(commentModalAtom, { isOpen: false, mode: null, data: null });
});
